import { Card, Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { FaEye, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ProfileOperatorsBusiness from "./Accounts/ProfileOperatorsBusiness";
import { useAuth } from "provider/AuthContext";
import { useEffect } from "react";
import { useOperatorProfileContext } from "provider/OperatorProfileProvider";
import apiCall from "components/Api/api";
import { handleError } from "components/Api/handleError";

const AccountOperator = () => {
  const { userProfile, logout } = useAuth();
  const { activeTabOp, operatorProfileDispatch } = useOperatorProfileContext();

  const navigate = useNavigate();

  useEffect(() => {
    const fetchOperatorProfile = async () => {
      try {
        operatorProfileDispatch({ type: "SET_OPERATOR_ACCOUNT_LOADING", payload: true });
        const response = await apiCall({
          url: `operator/${userProfile?.operator_slug}`,
        });

        if (response.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }

        if (response?.status === 200) {
          if (response?.data?.errors) {
            const errors = response?.data.errors;
            operatorProfileDispatch({
              type: "SET_OPERATOR_ACCOUNT_ERROR",
              payload: errors,
            });
            console.error(errors)
          } else {
            const profileData = response?.data?.data;
            operatorProfileDispatch({ type: 'SET_OPERATOR_ACCOUNT_SETTING_DATA', payload: profileData });

          }
        }
      } catch (error) {
        console.error("An error occurred while fetching user profile:", error);
        handleError(error, logout, navigate);
      } finally {
        operatorProfileDispatch({ type: "SET_OPERATOR_ACCOUNT_LOADING", payload: false });
      }
    };

    fetchOperatorProfile();
  }, [userProfile?.user_handle]);

  const handleTabSelect = (key) => {
    operatorProfileDispatch({
      type: "SET_ACTIVE_TAB_OPERATOR",
      payload: key
    });
  };
  return (
    <>
      <Container fluid="lg" className="mt-5 pt-5">
        <Tab.Container activeKey={activeTabOp} onSelect={handleTabSelect}>
          <Row className="margin_bottomfooter">
            <Col xs={12} className="d-flex align-items-center justify-content-between flex-wrap mb-4">
              <h6 className="fs-3 fw-bold">Developer | Manage Operator Business</h6>
              <div className="unsaved_changes text-danger"></div>
              <div className="justify-content-between">
                <button className="btn btn-info bg-blues py-2 rounded-5">
                  <FaEye className="me-1" />
                  View Profile
                </button>
              </div>
            </Col>
            {/* Sidebar nav */}
            <Col xxl={3} lg={4} className="d-none d-lg-block mb-4">
              <Card className="sidebar_account">
                <Card.Body className="nav nav-tabs flex-column nav-pills slider_accountsidebar">
                  <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                      <Nav.Link eventKey="profile-settings" className="mb-2">
                        <FaUser className="me-2" />
                        Profile Settings
                      </Nav.Link>
                    </Nav.Item>
                    {/* <Nav.Item>
                      <Nav.Link eventKey="shared-safaris" className="mb-2">
                        <FaLock className="me-2" />
                        Shared Safaris
                      </Nav.Link>
                    </Nav.Item> */}
                  </Nav>
                </Card.Body>
              </Card>
            </Col>

            {/* Tab content */}
            <Col xxl={9} lg={8} className="itenary_tabs account-settings-wrapper">
              <Tab.Content>
                <Tab.Pane eventKey="profile-settings">
                  <ProfileOperatorsBusiness />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </>
  );
};

export default AccountOperator;
